<div style="font-size:75%">
  <!--#region entête-->
  <div class="row mx-0 q-white" sstyle="border: 1px solid var(--c-dark-grey);">
    <!--mois précédent-->
    <button class="q-btn q-light-grey col-auto" (click)="PreviousMonth()"><i class="fas fa-chevron-left q-c-main"></i></button>
    <!--#region sélection du mois et de l'année '-->
    <div class="col" style="text-align: center;">

      <select class="q-main-select col-auto" [(ngModel)]="month" (ngModelChange)="OnMonthChange()">
        <option *ngFor="let m of months; let i = index" [value]="m">{{m}}</option>
      </select>

      <input type="number" name="year" [(ngModel)]="year" (ngModelChange)="OnYearChange($event)" class="my-0 ml-2 q-input-border" style="width: 100px;" />

      <!--<select #selectView class="q-main-select col-auto" (change)="OnViewChange(selectView.value)">
        <option value="dayGridMonth" selected>mois</option>
        <option value="timeGridWeek">semaine</option>
        <option value="timeGridDay">jour</option>
      </select>-->
    </div>
    <!--#endregion-->
    <!--mois suivant-->
    <button class="q-btn q-light-grey col-auto" (click)="NextMonth()"><i class="fas fa-chevron-right q-c-main"></i></button>
  </div>
  <!--#endregion-->

  <full-calendar *ngIf="planningService && planningService?.ListeReservations && planningService?.Filter" #calendar [options]="calendarOptions"></full-calendar><!--"planningService?.ListeReservations | PlanningResasToCalendar: planningService?.Filter?.DateDebut: planningService?.Filter?.DateFin: planningService?.Filter?.Formateurs: planningService?.Filter?.ShowOnlyNew: OnSelectRange: planningService: fullCalendar: planningService?.View"></full-calendar>-->
</div>
